import type { FaireProductEntity } from "../../entity_types/product";

export const p_ezkddn3tvu: FaireProductEntity = {
  token: "p_ezkddn3tvu",
  type: "product",
  name: "Wedding Rings Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/ab2891e1c254f84f152fdcc97deb9bb79bdd7f448b2a88725f97632d60b7e114.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/93aa30e3798e745e0d77ae66740f320df3d000e296e1d074accb47d601ba7760.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:32.063Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
